import { TraceContract } from '@terra/shared-contracts-trace';
import { createTerraOrpcClient } from '@terra/shared-utils';

const SERVICE_NAME = 'ai';

export const traceClient = createTerraOrpcClient({
  contract: TraceContract,
  serviceName: SERVICE_NAME,
});
